export const getPicklistListTab = (initialFilter = {}) => ({
  field: 'preset',
  isPreset: true,
  defaultTab: 'created',
  tabs: [
    {
      key: 'created',
      label: 'Created',
      preset: {
        ...initialFilter,
        picklist_status: ['created'],
      },
    },
    {
      key: 'packing',
      label: 'Packing',
      preset: {
        ...initialFilter,
        picklist_status: ['receiving'],
      },
    },
    {
      key: 'open',
      label: 'Open',
      preset: {
        ...initialFilter,
        picklist_status: ['created', 'receiving'],
      },
    },
    {
      key: 'all',
      label: 'All',
      preset: {
        ...initialFilter,
      },
    },
  ],
});

export const CREATE_PICKLIST_LIST_TAB = {
  field: 'is_single_sku',
  multiSelect: false,
  tabs: [
    { key: 'all', label: 'Invoicing' },
    {
      key: 'Invoicing - Single SKU',
      value: 'true',
      label: 'Invoicing - Single SKU',
    },
  ],
};
